export default "__VITE_ASSET__DtM2ospF__"